import { IntercomTracker } from "./IntercomTracker";
import { IntercomTrackerMock } from "./IntercomTrackerMock";
import { useMock } from "../utils/useMock";

export default (useMock() ? IntercomTrackerMock : IntercomTracker);